/*
 * @Author: your name
 * @Date: 2020-06-24 15:00:44
 * @LastEditTime: 2020-06-29 13:38:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\utils\auth.js
 */
// import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'
// const TokenKeys = 'vue_admin_template_token'
// const SafeKey = 'yt_tq_safe_key'

// export function getToken() {
//     return Cookies.get(TokenKey)
// }

// export function setToken(token) {
//     return Cookies.set(TokenKey, token)
// }
// export function getTokens() {
//     return Cookies.get(TokenKeys)
// }

// export function setTokens(tokens) {
//     return Cookies.set(TokenKeys, tokens)
// }
// export function removeToken() {
//     return Cookies.remove(TokenKey)
// }



// export function setSafe(token) {
//     return Cookies.set(SafeKey, token)
// }

// export function removeSafe() {
//     return Cookies.remove(SafeKey)
// }
import Cookies from 'js-cookie'
import store from '../store'
const TokenKey = 'Admin-Token'
const TokenKeys = 'vue_admin_template_token'
const SafeKey = 'yt_tq_safe_key'

export function getToken() {
  if (store && store.getters && store.getters.token) return store.getters.token
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 1 })
}
export function getTokens() {
  if (store && store.getters && store.getters.partToken) return store.getters.partToken
  return Cookies.get(TokenKeys)
}
export function getTokenGps() {
  if (store && store.getters && store.getters.partToken) return store.getters.partToken
  return Cookies.get(TokenKeys)
}
export function setTokens(token) {
  return Cookies.set(TokenKeys, token, { expires: 1 })
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function removeTokens() {
  return Cookies.remove(TokenKeys)
}
export function getSafe() {
    return Cookies.get(SafeKey)
}
export function removeSafe() {
    return Cookies.remove(SafeKey)
}